export const APP_STORE_LINKS = {
  android:
    'https://play.google.com/store/apps/details?id=com.countrychicken.customerapp',
  ios: 'https://apps.apple.com/in/app/country-chicken-co/id6455496228',
};
